import React from 'react';
import { Helmet } from 'react-helmet-async';

import { isServer } from '../../util/cookies';
import {ensureCurrentUser} from "../../util/data";
import {pathOr} from "ramda";
import {connect} from "react-redux";

const BrevoTrackingTagComponent = (props) => {
  const { currentUser } = props;
  const user = ensureCurrentUser(currentUser);
  const currentEmail = pathOr('', ['attributes', 'email'], user);
  if (isServer()) return null;


  return (
    <div>
      <Helmet>
        <script type="text/javascript">
          {`
           (function() {
              if (typeof window === 'undefined') return;

              window.sib = {
                  equeue: [],
                  client_key: "jph5myemcwjbx472f6yckcbd"
              };
              /* OPTIONAL: email for identify request*/
              window.sib.email_id = '${currentEmail}';
              window.sendinblue = {};
              for (var j = ['track', 'identify', 'trackLink', 'page'], i = 0; i < j.length; i++) {
              (function(k) {
                  window.sendinblue[k] = function() {
                      var arg = Array.prototype.slice.call(arguments);
                      (window.sib[k] || function() {
                              var t = {};
                              t[k] = arg;
                              window.sib.equeue.push(t);
                          })(arg[0], arg[1], arg[2], arg[3]);
                      };
                  })(j[i]);
              }
              var n = document.createElement("script"),
                  i = document.getElementsByTagName("script")[0];
              n.type = "text/javascript", n.id = "sendinblue-js", n.async = !0, n.src = "https://sibautomation.com/sa.js?key=" + window.sib.client_key, i.parentNode.insertBefore(n, i), window.sendinblue.page();
          })();`}
        </script>
      </Helmet>
    </div>
  )
};


const mapStateToProps = state => ({
  currentUser: pathOr({}, ['user', 'currentUser'], state),
});

const BrevoTrackingTag = connect(mapStateToProps)(BrevoTrackingTagComponent);

export default BrevoTrackingTag;
